<template>
  <div class="flex flex-wrap" id="profile-dropdown">
    <div class="w-full px-4">
      <div class="relative inline-flex align-middle w-full">
        <div class=""></div>
        <div
          class="text-center flex items-center"
          v-on:click="!isPreview ? toggleDropdown() : 'null'"
        >
          <span
            class="
              hidden
              md:block
              w-8
              text-white
              h-8
              rounded-full
              inline-block
              host-social-icon
              cursor-pointer
              mr-2
              flex
              items-center
              justify-center
              bg-grey-100
              pt-1
            "
          >
            <i class="fa fa-user h-4 w-4"></i>
          </span>
          <span class="text-sm text-grey-700 mr-2"
            >{{ $t('frontend_groovemember_top_navbar_profile_dropdown_hey') }}
            {{ user.name }}!</span
          >
          <span><i class="fa fa-angle-down h-4 w-4"></i></span>
        </div>

        <div
          v-if="showDropdown && !isPreview"
          class="
            absolute
            bg-white
            text-base
            float-left
            py-2
            list-none
            text-left
            rounded
            shadow-lg
            mt-1'
          "
          style="min-width: 10rem; z-index: 60; top: 3.5rem; margin-left: 35px"
        >
          <a
            href="#level"
            class="
              text-sm
              py-2
              px-4
              font-normal
              block
              w-full
              whitespace-nowrap
              bg-transparent
              text-gray-800
            "
          >
            {{
              $t('frontend_groovemember_top_navbar_profile_dropdown_level')
            }}
            : {{ user.level.name }}
          </a>
          <a
            @click="goToSettings()"
            class="
              text-sm
              py-2
              px-4
              font-normal
              block
              w-full
              whitespace-nowrap
              bg-transparent
              text-gray-800
            "
          >
            {{
              $t('frontend_groovemember_top_navbar_profile_dropdown_settings')
            }}
          </a>
          <a
            v-if="isPortal"
            @click="backToPortal()"
            class="
              text-sm
              py-2
              px-4
              font-normal
              block
              w-full
              whitespace-nowrap
              bg-transparent
              text-gray-800
            "
          >
            {{
              $t(
                'frontend_groovemember_top_navbar_profile_dropdown_back_to_portal'
              )
            }}
          </a>
          <a
            v-else
            @click="logoutTrigger"
            class="
              text-sm
              py-2
              px-4
              font-normal
              block
              w-full
              whitespace-nowrap
              bg-transparent
              text-gray-800
            "
          >
            {{ $t('frontend_groovemember_top_navbar_profile_dropdown_logout') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileDropDown',
  props: [
    'user',
    'baseUrl',
    'isPreview',
    'logout',
    'profile',
    'backPortalPage',
    'isPortal',
  ],
  data() {
    return {
      showDropdown: false,
    };
  },
  methods: {
    toggleDropdown: function () {
      this.showDropdown = !this.showDropdown;
    },
    logoutTrigger() {
      this.logout();
    },
    goToSettings() {
      this.profile();
    },
    backToPortal() {
      this.backPortalPage();
    },
  },
};
</script>

